module.exports = __webpack_public_path__ + "img/1506230228.d61e8ded.jpg";